// extracted by mini-css-extract-plugin
export default {"container":"recommendationContainer-module__container__C7GCC","recommended":"recommendationContainer-module__recommended__PEkhQ"};